export default "__VITE_ASSET__483285e5__"